<template>
  <div class="flex flex-col items-center">
    <div class="hobbies-row flex flex-col lg:flex-row gap-8 lg:gap-20 justify-center items-center lg:items-start">
      <BaseCard :title="'Embroidery'" :highlight-last-word="true" :compact="true" class="hobby-card hobby-card-embroidery">
        <div class="flex flex-col items-center gap-4">
          <p class="text-center space-y">
            <span class="block">I like to embroider and cross stitch, mainly floral and nature designs</span>
            <span class="block">I create most of my designs myself, here are a few!</span>
          </p>
          <img :src="EmbroideryImage" 
            class="w-full max-w-xs sm:max-w-sm lg:max-w-[50%] cursor-pointer" 
            @click="openImageMenu(EmbroideryImage, 'Embroidery', $event.currentTarget)">
        </div>
      </BaseCard>
      <BaseCard :title="'Poetry'" :highlight-last-word="true" :compact="true" class="hobby-card hobby-card-poetry">
        <div class="flex flex-col items-center gap-4">
          <p class="text-center space-y">
            <span class="block">I write quite a lot of poetry, usually spurred by my love for nature and the simple things.</span>
            <span class="block">My favorite poet is Mary Oliver and I take much inspiration from her.</span>
            <span class="block">There's so much to life that goes unnoticed, why not try to appreciate it a little?</span>
            <span class="block">Here's a favorite that I've written, which may be published soon!</span>
          </p>
          <img :src="PoetryImage" 
            class="w-full max-w-sm lg:max-w-[70%] cursor-pointer" 
            @click="openImageMenu(PoetryImage, 'Poetry', $event.currentTarget)">
        </div>
      </BaseCard>
    </div>
    <div class="flex flex-col gap-20 items-center">
      <BaseCard :title="'Flowers!'" :highlight-last-word="false" class="w-auto">
        <div class="flex flex-col items-center gap-4">
          <p>I have deep love of flowers after spending most of my childhood afternoons in my family's flower shop.
            From designing arrangements to the Victorian meaning of certain flowers, the language of flowers enthralls me.  I try to make a couple arrangements every time I return home from college, both for the flowers and for my family. Here are some of my recent creations:
          </p>
          <div class="grid grid-cols-1 lg:grid-cols-3 gap-2 w-full place-items-center">
            <img :src="Roses" class="flex-1 max-h-100 object-cover rounded-lg cursor-pointer" @click="openImageMenu(Roses, 'Roses', $event.currentTarget)">
            <img :src="Daisies" class="flex-1 max-h-100 object-cover rounded-lg cursor-pointer" @click="openImageMenu(Daisies, 'Daisies', $event.currentTarget)">
            <img :src="Corsage" class="flex-1 max-h-100 object-cover rounded-lg cursor-pointer" @click="openImageMenu(Corsage, 'Corsage', $event.currentTarget)">
          </div>
          <p>
            <span class="block">Fun fact about me: daisies will forever be my favorite flower! To me, daisies symbolize growth and positivity in my life that I used to not be able to see, which gives me another reason to wake up every day. Since they commonly grew in my backyard as a child, they often remind me of my inner child, helping me stay in tact with the beauty of life and especially my own life. My dad has taken this to heart as well, giving me a bouqet of daisies every time I leave for Notre Dame to remind me of him.</span>
            <span class="block">In Victorian terms, daisies symbolize childhood and innocence, opening the gates for one's inner child to live amidst the stresses of adult life. I try to take this meaning to heart in times of stress, remembering that there will always be a daisy waiting for me on the other side.</span>
          </p>
        </div>
      </BaseCard>
    </div>
  </div>
</template>

<script lang="ts" setup>
import BaseCard from '@/features/global/BaseCard.vue';
import EmbroideryImage from '@/assets/Projects/PersonalProjects/CrossStitch.jpg';
import PoetryImage from '@/assets/Projects/PersonalProjects/DewDroppedDeath.png';
import Roses from '@/assets/Projects/PersonalProjects/FlowersPhotos/Roses.jpg';
import Daisies from '@/assets/Projects/PersonalProjects/FlowersPhotos/Daisies.jpg';
import Corsage from '@/assets/Projects/PersonalProjects/FlowersPhotos/Corsage.jpg';
import { useImageViewer } from '@/features/composables/useImageViewer';

const { openImageMenu } = useImageViewer();
</script>

<style scoped>
.hobbies-row {
  width: 100%;
}

.hobby-card {
  flex: 0 1 auto;
  width: fit-content;
  max-width: 100%;
}

@media (min-width: 1024px) {
  .hobby-card-embroidery {
    margin-top: 4rem;
  }

  .hobby-card-poetry {
    margin-top: 8rem;
  }
}

@media (max-width: 1023px) {
  .hobby-card {
    align-self: center;
  }
}

</style>